module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAIAAAA4AQMAAADtmbusAAAAA1BMVEXa2t2k0Q7AAAAAC0lEQVQI12OgMwAAAHAAAR759tMAAAAASUVORK5CYII="